import type { ReactNode } from "react";
import { authJourneyStyles as styles } from "./auth-journey";

export function AuthActions({
  children,
  secondary,
}: {
  children: ReactNode;
  secondary?: ReactNode;
}) {
  return (
    <div className={styles.actions}>
      {children}
      {secondary ? (
        <div className={styles.secondaryActions}>{secondary}</div>
      ) : null}
    </div>
  );
}
